import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import StyleSelector from "../pages/style-selector/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/style-selector",
    element: <StyleSelector />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
